import { render, staticRenderFns } from "./search-box.component.vue?vue&type=template&id=68f85a4a"
import script from "./search-box.component.vue?vue&type=script&lang=ts"
export * from "./search-box.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports